import { render, staticRenderFns } from "./ywjk.vue?vue&type=template&id=6d3db6da&scoped=true&"
import script from "./ywjk.vue?vue&type=script&lang=js&"
export * from "./ywjk.vue?vue&type=script&lang=js&"
import style0 from "./ywjk.vue?vue&type=style&index=0&id=6d3db6da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3db6da",
  null
  
)

export default component.exports